// Framework
import {
  FETCH_THREAD_REQUEST,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  SELECT_USER,
  fetchThreadError,
  fetchThreadSuccess,
  fetchUsersError,
  fetchUsersSuccess
} from './actions';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { getConversations, getThread } from 'api/messages';
import { getAuth } from 'actions/auth/login';
import { getLocale } from 'actions/language/selectors';
import { getUserId } from './selectors';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';
import { selectUser } from 'actions/communication/compose/composeActions';

/*** Fetch Users ***/
// Worker
export function* fetchUsersWorker() {
  try {
    const auth = yield select(getAuth);
    const locale = yield select(getLocale);
    const data = yield call(getConversations, locale, auth);
    yield put(fetchUsersSuccess(data.communications));
  } catch (err) {
    // TODO: create saga for pushing notification
    yield pushFormattedError(err);
    yield put(fetchUsersError({ title: err.id, messages: err.messages[0] }));
  }
}

// Watcher
export function* fetchUsersSaga() {
  yield takeEvery(FETCH_USERS_REQUEST, fetchUsersWorker);
}

/*** Fetch Messages ***/
// Worker
export function* fetchThreadWorker() {
  try {
    const auth = yield select(getAuth);
    const locale = yield select(getLocale);
    const userId = yield select(getUserId);
    const { communications } = yield call(getThread, locale, auth, userId);
    yield put(fetchThreadSuccess(communications));
  } catch ({ id: title, messages }) {
    yield put(fetchThreadError({ title, messages }));
  }
}

// Watcher
export function* fetchThreadSaga() {
  yield all([
    takeEvery(FETCH_THREAD_REQUEST, fetchThreadWorker),
    takeEvery(FETCH_USERS_SUCCESS, fetchThreadWorker),
    takeEvery(SELECT_USER, fetchThreadWorker)
  ]);
}

/*** Select User Effect ***/
// Worker
export function* selectUserWorker() {
  try {
    const id = yield select(getUserId);
    yield put(selectUser({ id }));
  } catch (err) {
    yield pushFormattedError(err);
  }
}

// Watcher
export function* selectUserSaga() {
  yield takeEvery(SELECT_USER, selectUserWorker);
}



// WEBPACK FOOTER //
// ./src/actions/communication/messages/sagas.js